export default __webpack_public_path__ + "static/media/createDog_1.b0ef1791.jpg";